import { create } from "zustand";
import { persist } from "zustand/middleware";

export type NotificationStoreState = {
  isStorageNoticeDismissed: boolean;
  setIsStorageNoticeDismissed: (isStorageNoticeDismissed: boolean) => void;
  reset: () => void;
  dismissedAnnouncements: string[];
  dismissAnnouncement: (announcementId: string) => void;
};

export const useNotificationStore = create<NotificationStoreState>()(
  persist(
    (set) => ({
      isStorageNoticeDismissed: false,
      setIsStorageNoticeDismissed: (isStorageNoticeDismissed: boolean) =>
        set({ isStorageNoticeDismissed }),
      reset: () => set({ isStorageNoticeDismissed: false }),
      dismissedAnnouncements: [],
      dismissAnnouncement: (announcementId: string) =>
        set((state) => ({
          dismissedAnnouncements: [
            ...state.dismissedAnnouncements,
            announcementId,
          ],
        })),
    }),
    {
      name: "classview-notification-store",
      partialize: (state) => ({
        dismissedAnnouncements: state.dismissedAnnouncements,
      }),
    },
  ),
);
